

import axios from "axios";
import { showNotification } from "../Toast/Toast";

// const BASE_URL = "http://localhost:8000/api/user";
const BASE_URL = "https://bookizap-backend.onrender.com/api/user";


// ✅ Plain Axios (no token)
export const plainAxios = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// ✅ Authenticated Axios
export const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// ✅ Add access token to every request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    showNotification({ message: "Request error", type: "error" });
    return Promise.reject(error);
  }
);

// 🔄 Refresh token handling
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

const refreshToken = async () => {
  const storedRefreshToken = sessionStorage.getItem("refreshToken");
  if (!storedRefreshToken) throw new Error("No refresh token");

  const response = await plainAxios.post("/auth/refreshToken", {
    refreshToken: storedRefreshToken,
  });

  const { token: newAccessToken, refreshToken: newRefreshToken } = response.data;

  sessionStorage.setItem("token", newAccessToken);
  if (newRefreshToken) {
    sessionStorage.setItem("refreshToken", newRefreshToken);
  }

  return newAccessToken;
};

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const status = error?.response?.status;

    if (status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`;
            return axiosInstance(originalRequest);
          })
          .catch((err) => Promise.reject(err));
      }

      isRefreshing = true;

      try {
        const newToken = await refreshToken();
        processQueue(null, newToken);
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      } catch (err) {
        processQueue(err, null);
        sessionStorage.clear();
        window.location.href = "/login";
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    // Handle other errors
    const msg = error?.response?.data?.message || "Something went wrong";
    if (status === 403) {
      showNotification({ message: "You do not have permission.", type: "error" });
    } else if (status === 500) {
      showNotification({ message: "Server error. Please try later.", type: "error" });
    } else if (status !== 401) {
      showNotification({ message: msg, type: "error" });
    }

    return Promise.reject(error);
  }
);


